import React from "react";
import MaterialIcon from "../BuilderComponents/MaterialIcon";

const RVColumnsManagerPreview = ({ config, classes }) => {
  const icon = config?.icon?.split(" ")[0] || "";
  return (
    <div className={`z-column-manager-icon d_flex align_center justify_center ${classes}`} title={config.title}>
      <MaterialIcon name={icon} />
    </div>
  );
};

export default RVColumnsManagerPreview;
